module.exports = __webpack_public_path__ + "static/media/MUTHOOTFIN.ba98b9a4.txt";